<template>
  <v-text-field v-model="formattedNumber" :label="label" class="right_aligned-input" :dense="dense" :disabled="readonly"
    :readonly="formOptions.disableAll" ref="field" @keypress="isNumber($event)" hide-details="auto">
  </v-text-field>
</template>

<script>
import { Utilities as _utils } from "@/shared/utilities";
import AutoNumeric from "autonumeric";
import { locale } from 'moment';

export default {
  components: {},
  name: "FormattedNumber",
  props: [
    "model",
    "label",
    "name",
    "format",
    "currency",
    "options",
    "dense",
    "readonly",
    "precision",
    "formOptions"
  ],

  mounted() {
    if (this.format === "currency2") {
      new AutoNumeric(this.$refs.field.$refs.input, {
        currencySymbol: _utils.currencyHandler(this.currency || 'EUR'),
        currencySymbolPlacement: "p",
        decimalPlaces: this.precision || 2,
        emptyInputBehavior: 'always'
      });
    } else if (this.format === "decimal") {
      new AutoNumeric(this.$refs.field.$refs.input, {
        decimalPlaces: this.precision || 2
      });
    }
  },

  computed: {
    formattedNumber: {
      get: function () {
        return this.formatNumber(this.model, (this.precision || 0), locale);
      },
      set: function (newValue) {
        this.$emit("update", Number(newValue.replace(/[^0-9\.-]+/g,"")));
      },
    },
  },
  methods: {
    /** check whther thr key in charcter is number */
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    /** method to format the number values */
    formatNumber: function (value, dec) {
      try {
        dec = dec || 0;
        if ([null, undefined, "", NaN].includes(value)) {
          return "";
        }
        switch (this.format) {
          // #. currency format
          case "currency":
            return _utils.formatCurrency(value, this.currency, locale);
            break;

          case "currency2":
            return _utils.formatCurrency2(value, this.currency);
            break;

          // #. decimal format
          case "decimal":
          default:
            return _utils.formatDecimal(value, dec, locale);
            break;
        }
      } catch (e) {
        return value;
      }
    },
  },
};
</script>

<style scoped>
</style>
